module App.Interfaces {
    export interface ISnackbarFactory {
        show(text: string, duration: number): void;
    }
}

